import(/* webpackMode: "eager" */ "/app/node_modules/next/dist/client/link.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/app/training/[id]/CourseVideo.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/app/training/[id]/ModalModeHandler.tsx");
